import { HistoryServiceV2 } from '@feature-hub/history-service';
import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { DisclaimerManagerV1 } from '@volkswagen-onehub/disclaimer-manager';
import { LayerManagerV24 } from '@volkswagen-onehub/layer-manager';
import { NavigationServiceV1 } from '@volkswagen-onehub/navigation-service';
import { PageInfoServiceV1 } from '@volkswagen-onehub/page-info-service';
import { ServiceConfigProviderV1 } from '@volkswagen-onehub/service-config-provider';
import { IProfileServiceV2, UserService } from '@vwdfive/myvw-services';
import React, { useContext } from 'react';
import { PortalServiceV1 } from '@esportal/portal-service';
import { FeatureappServiceV1 } from '@volkswagen-onehub/featureapp-service';
import { FaContentServiceV1 } from '@volkswagen-onehub/fa-content-service';
import { TrackingManagerV1 } from '@volkswagen-onehub/tracking-service';
import { UserInteractionServiceV1 } from '@volkswagen-onehub/user-interaction-service';

export interface IMastersContext {
	readonly featureAppId: string;
	readonly authService: IAuthServiceV2;
	readonly profileService: IProfileServiceV2;
	readonly userService: UserService;
	readonly portalService: PortalServiceV1;
	readonly layerManager: LayerManagerV24;
	readonly serviceConfigProvider: ServiceConfigProviderV1;
	readonly featureServices: any;
	readonly historyService: HistoryServiceV2;
	readonly disclaimerManager: DisclaimerManagerV1;
	readonly breacrumbService: BreadcrumbServiceV1;
	readonly pageInfoService: PageInfoServiceV1;
	readonly navigationService: NavigationServiceV1;
	readonly featureAppService: FeatureappServiceV1;
	readonly contentService: FaContentServiceV1;
	readonly tracking: TrackingManagerV1;
	readonly userInteractionService: UserInteractionServiceV1;
}

const defaultContext: IMastersContext = {
	featureAppId: '' as string,
	authService: {} as IAuthServiceV2,
	profileService: {} as IProfileServiceV2,
	userService: {} as UserService,
	portalService: {} as PortalServiceV1,
	layerManager: {} as LayerManagerV24,
	serviceConfigProvider: {} as ServiceConfigProviderV1,
	featureServices: null,
	historyService: {} as HistoryServiceV2,
	breacrumbService: {} as BreadcrumbServiceV1,
	disclaimerManager: {} as DisclaimerManagerV1,
	pageInfoService: {} as PageInfoServiceV1,
	navigationService: {} as NavigationServiceV1,
	featureAppService: {} as FeatureappServiceV1,
	contentService: {} as FaContentServiceV1,
	tracking: {} as TrackingManagerV1,
	userInteractionService: {} as UserInteractionServiceV1,
};

export const MastersContext = React.createContext<IMastersContext>(defaultContext);
MastersContext.displayName = 'PortalContext';

export function useFeatureService(): any {
	const { featureServices } = useContext(MastersContext);
	if (!featureServices) {
		throw new Error('No featureServices context value was provided.');
	}
	return featureServices;
}
